module.exports = __webpack_public_path__ + "fonts/Inter-500-greek35.3a3cf1a.woff2";